import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { SelectionService, Selection } from 'common/util/module'
import { TapeFile } from 'elements-sdk'
import { TapeRestorerService } from '../services/tapeRestorer.service'

@Component({
  templateUrl: './restoreAddModal.component.pug',
})
export class RestoreAddModalComponent {
  @Input() entries: TapeFile[]
  loading = true
  selection: Selection<TapeFile>

  constructor (
    private modalInstance: NgbActiveModal,
    private api: APIService,
    private tapeRestorer: TapeRestorerService,
    selection: SelectionService,
  ) {
    this.selection = selection.make()
  }

  async ngOnInit () {
    const entryLists = await Promise.all(this.entries.map(entry =>
      this.api.tapeArchive.getAllArchivedFileEntries({
        fullpath: entry.path,
      }),
    ))
    this.loading = false
    this.entries = entryLists.flat()
    this.selection.setObjects(this.entries)
    this.selection.selectAll()
    if (this.entries.length === 1) {
      this.enqueue()
    }
  }

  enqueue () {
    this.tapeRestorer.enqueue(this.selection.get(), true)
    this.modalInstance.close()
  }

  cancel () {
    this.modalInstance.dismiss()
  }
}
